import { LibraryThing } from "../../ls2pac/widget/LibraryThingWidget";
import { seriesLogo } from "../SeriesLogo";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsSeriesManager } from "../managers/seriesManager";

/**
 * A grid icon.
 * tlc.ls2kids.model.SeriesIcon
 */
export class KidsSeriesIcon {
	constructor(series, layoutItem) {
		var _this = this;

		this.element = $('<li></li>')
			.addClass('icon');


		this._rawImage = new Image();

		this._rawImage.onload = function (response) {
			if (_this._rawImage.height > 1) {
				_this.element.addClass("loaded");
			}

			// console.log("title height: ", $(_this.element).find(".seriesTitle").height());
			var currentTitleElement = $(_this.element).find(".seriesTitle");
			var currentTitleHeight = currentTitleElement.height();
			var currentHeightOffset = (currentTitleHeight / 2) * -1;

			currentTitleElement.css('margin-top', currentHeightOffset + "px");

			window.requestAnimationFrame(function () {
				if (window.Modernizr.csstransitions) {
					_this._icon = $('<div class="image"></div>')
						.css({
							"background-image": "url( " + _this._rawImage.src + ")"
						});
				} else {
					_this._icon = $('<img />')
						.attr('src', _this._rawImage.src)
						.hide();

					setTimeout(function () {
						_this._icon.show();
						_this._icon.removeAttr("width");
						_this._icon.removeAttr("height");
						_this._icon.centerVertically2();
					}, 250);
				}

				_this._background.append(_this._icon);
			});
		};

		this._rawImage.onerror = function (response) {
			// debugger;
		};

		this.series = series;

		this.imageType = layoutItem.type;
		this.id = series.id;
		this.guid = series.guid;
		this.name = series.name;
		this.logos = series.logos;
		this.contentImageIdentifier = series.contentImageIdentifier;
		this.contentImageIdentifierType = series.contentImageIdentifierType;

		this.setIcon(series.logos);
	}
	/**
	 * Render the icon
	 */
	render() {
		var _this = this;

		// TODO: confirm this is okay
		// same goes for the categories page
		// var title = $( '<p class="seriesTitle">' + this.name + '</p>' );
		var link = $('<a></a>')
			.attr('aria-label', this.name)
			// TODO: externalize URL
			.attr('href', '/kids#' + LS2KIDS_CONSTANTS.Urls.seriesSearch + '?seriesId=' + this.id);

		this.element.append(link);
		this._background = $('<div></div>')
			.addClass('glass-like-background');

		link.append(this._background);
	}
	/**
	 * Resize the icon
	 * @param {number} width
	 * @param {number} height
	 * @param {number} rowMargin
	 * @param {number} colMargin
	 */
	resize(width, height, rowMargin, colMargin) {
		this._cellHeight = height;
		this._cellWidth = width;
		this._rowMargin = 15;
		this._colMargin = 15;

		this._colMargin = colMargin;

		var getFn = function (command) {
			if (command == "width") {
				return width;
			}

			return height;
		};

		if (this.imageType != KidsSeriesManager.imageTypes.STYLE_JACKET) {
			if (this.imageType == KidsSeriesManager.imageTypes.STYLE_1) {
				getFn = this.getSpecialStyle1;
			}

			if (this.imageType == KidsSeriesManager.imageTypes.STYLE_2) {
				getFn = this.getSpecialStyle2;
			}
		}

		this.element.css({
			'width': getFn.apply(this, ['width', width]),
			'height': getFn.apply(this, ['height', height])
		});

		//	this._icon.centerVertically2();
		this.resetPosition();

		if (!window.Modernizr.csstransitions && this._icon) {
			this._icon.centerVertically2();
		}
	}
	setIcon(image) {
		var _this = this, iconUrl = null;

		if (image && image.length > 0) {
			iconUrl = seriesLogo(this.logos[0], 0, 0);
			this.element.addClass('special-series-icon');
		} else {
			if (this.contentImageIdentifierType == null || this.contentImageIdentifier == null || this.contentImageIdentifier.length == 0) {
				this.element.addClass('missing-default');
			} else {
				iconUrl = LibraryThing.getSeriesLogo(
					LibraryThing.enums.requestType.bookJacketLarge,
					[{ "type": this.contentImageIdentifierType, "data": this.contentImageIdentifier }],
					this.name
				);
			}
		}

		if (iconUrl != null) {
			setTimeout(function () {
				window.requestAnimationFrame(function () {
					_this._rawImage.src = iconUrl;
				});
			}, 1500 * this.page);
			//		this._icon.get( 0 ).src = iconUrl;
			//		this._icon.attr( 'src', iconUrl );
			//		this._icon.attr( 'src', "/images/kids/glass-68.png");
		}
	}
	/**
	 * Hide the icon
	 */
	hide() {
		this.element.hide();
	}
	/**
	 * Show the icon
	 */
	show() {
		this.element.show();
	}
	/**
	 * move the icon back to where it should be
	 */
	resetPosition() {
		var getFn = function (command, size) {
			return size;
		};

		if (this.imageType != KidsSeriesManager.imageTypes.STYLE_JACKET) {
			if (this.imageType == KidsSeriesManager.imageTypes.STYLE_1) {
				getFn = this.getSpecialStylePosition1;
			}

			if (this.imageType == KidsSeriesManager.imageTypes.STYLE_2) {
				getFn = this.getSpecialStylePosition2;
			}
		}

		this.element.css({
			position: 'absolute',
			'left': getFn.apply(this, ['left', this.left]),
			'top': getFn.apply(this, ['top', this.top])
		});
	}
	move(left, top) {
		this.element.css({
			position: 'fixed',
			left: left,
			top: top
		});
	}
	getSpecialStyle1(command, value) {
		if (command == "height") {
			return (value - this._rowMargin) * 0.35;
		}

		return value;
	}
	getSpecialStyle2(command, value) {
		if (command == "height") {
			var topTileHeight = (value - this._rowMargin) * 0.35;

			return value - topTileHeight - this._rowMargin;

			//		return ( ( value - this._rowMargin ) * 0.65 ) + this._rowMargin;
		}

		return value;
	}
	getSpecialStylePosition1(command, value) {
		return value;
	}
	getSpecialStylePosition2(command, value) {
		if (command == "top") {
			var topTileHeight = (this._cellHeight - this._rowMargin) * 0.35;

			return topTileHeight + this._rowMargin + value; // + ( height  - this._rowMargin ) * 0.35;
		}

		return value;
	}
}

/**
 * @type {number}
 */
KidsSeriesIcon.prototype.id = 0;

/**
 * @type {string}
 */
KidsSeriesIcon.prototype.name = '';

/**
 * @type {jQuery|null}
 */
KidsSeriesIcon.prototype.element = null;

/**
 * @type {number}
 */
KidsSeriesIcon.prototype.index = 0;

/**
 * @type {number}
 */
KidsSeriesIcon.prototype.row = 0;

/**
 * @type {number}
 */
KidsSeriesIcon.prototype.col = 0;

/**
 * @type {number}
 */
KidsSeriesIcon.prototype.left = 0;

/**
 * @type {number}
 */
KidsSeriesIcon.prototype.top = 0;

/**
 * @type {number}
 */
KidsSeriesIcon.prototype.page = 0;

/**
 * @type {jQuery}
 */
KidsSeriesIcon.prototype._background = null;

/**
 * @type {jQuery}
 */
KidsSeriesIcon.prototype._icon = null;

/**
 * @type {number} where the series icon is in terms of placement with in a "cell"
 */
KidsSeriesIcon.prototype.position = null;

/**
 * @type {Array.<Object>} an array of logos
 */
KidsSeriesIcon.prototype.logos = null;
/**
 * @type {String} the value of the contentImageIdentifierType (e.g. the actual ISBN number)
 */
KidsSeriesIcon.prototype.contentImageIdentifier = null;

/**
 * @type {String} the type of number that contentImageIdentifier is (ISBN, ISSN, etc)
 */
KidsSeriesIcon.prototype.contentImageIdentifierType = null;















